import { useEffect } from 'react';
import { useMap } from 'react-map-gl/maplibre';

export function MapImage({ name, url, sdf }) {
  const { current: map } = useMap();

  useEffect(() => {
    if (!map) return;

    async function addImage() {
      if (map.hasImage(name)) return;
      const { data } = await map.loadImage(url);
      if (!map.hasImage(name)) {
        map.addImage(name, data, { sdf });
      }
    }

    // Re-add images whenever the style reloads (style changes clear all images).
    map.on('style.load', addImage);

    if (map.isStyleLoaded()) {
      addImage();
    }

    return () => {
      map.off('style.load', addImage);
    };
  }, [map, name, url, sdf]);

  return null;
}
